/* Royale · landing premium — interacciones (carrusel, FAQ, barra fija, reveal) */
(function(){
  if(window.__roBooted) return; window.__roBooted = true;
  var d = document;
  function qa(s,c){return Array.prototype.slice.call((c||d).querySelectorAll(s));}

  function boot(){
    /* marca de página premium (aísla el pulido del buy box a estas plantillas) */
    d.body.classList.add('ro-premium');

    /* scroll al panel de compra */
    qa('[data-ro-buy]').forEach(function(b){
      b.addEventListener('click', function(e){
        e.preventDefault();
        var t = d.querySelector('.ro-buypanel') || d.querySelector('form[action*="/cart/add"]') || d.querySelector('#MainContent');
        if(t) t.scrollIntoView({behavior:'smooth', block:'center'});
      });
    });

    /* galería: cambiar imagen principal al tocar miniatura */
    qa('[data-ro-gallery]').forEach(function(g){
      var main = g.querySelector('[data-ro-main]');
      qa('[data-ro-thumb]', g).forEach(function(t){
        t.addEventListener('click', function(){
          if(main) main.src = t.getAttribute('data-ro-thumb');
          qa('[data-ro-thumb]', g).forEach(function(o){ o.classList.remove('is-active'); });
          t.classList.add('is-active');
        });
      });
    });

    /* selector de cantidad */
    qa('.ro-qty').forEach(function(q){
      var inp = q.querySelector('[data-ro-qty]');
      var clamp = function(n){ n = parseInt(n,10); if(isNaN(n)||n<1) n=1; if(n>99) n=99; return n; };
      var minus = q.querySelector('[data-ro-qminus]');
      var plus = q.querySelector('[data-ro-qplus]');
      if(minus) minus.addEventListener('click', function(){ inp.value = clamp(inp.value) - 1 < 1 ? 1 : clamp(inp.value) - 1; });
      if(plus) plus.addEventListener('click', function(){ inp.value = clamp(inp.value) + 1; });
      if(inp) inp.addEventListener('change', function(){ inp.value = clamp(inp.value); });
    });

    /* carrusel de testimonios */
    qa('.ro-testi').forEach(function(sec){
      var track = sec.querySelector('.ro-testi__track');
      var prev = sec.querySelector('[data-ro-prev]');
      var next = sec.querySelector('[data-ro-next]');
      if(!track) return;
      function step(){ var c = track.querySelector('.ro-testi__card'); return c ? c.getBoundingClientRect().width + 20 : 320; }
      if(prev) prev.addEventListener('click', function(){ track.scrollBy({left:-step(), behavior:'smooth'}); });
      if(next) next.addEventListener('click', function(){ track.scrollBy({left:step(), behavior:'smooth'}); });
    });

    /* FAQ: solo una abierta */
    var faqs = qa('.ro-faq__item');
    faqs.forEach(function(det){
      det.addEventListener('toggle', function(){
        if(det.open) faqs.forEach(function(o){ if(o!==det) o.open=false; });
      });
    });

    /* barra fija: aparece al pasar el hero, se esconde cerca del pie */
    var bar = d.querySelector('.ro-sticky');
    if(bar){
      var onScroll = function(){
        var y = window.pageYOffset || d.documentElement.scrollTop;
        var footer = d.querySelector('footer');
        var nearEnd = footer ? (y + window.innerHeight > footer.getBoundingClientRect().top + y - 40) : false;
        bar.classList.toggle('is-on', y > 620 && !nearEnd);
      };
      window.addEventListener('scroll', onScroll, {passive:true});
      onScroll();
    }

    /* reveal al hacer scroll */
    var rev = qa('.ro-reveal');
    if('IntersectionObserver' in window && rev.length){
      var io = new IntersectionObserver(function(en){
        en.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, {threshold:.12});
      rev.forEach(function(el){ io.observe(el); });
    } else { rev.forEach(function(el){ el.classList.add('is-in'); }); }
  }

  if(d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

/* === LAND · Royale — carrito AJAX + Comprar ahora (sin selector de cantidad) === */
(function(){
  if(window.__roCart) return; window.__roCart = true;
  var d = document;
  function addToCart(form){
    var i = form.querySelector('[name="id"]');
    if(!i || !i.value) return Promise.reject(new Error("sin variante"));
    return fetch("/cart/add.js", {
      method:"POST", headers:{"Content-Type":"application/json","Accept":"application/json"},
      body: JSON.stringify({ items:[{ id: Number(i.value), quantity: 1 }] })
    }).then(function(r){ if(!r.ok) throw new Error("add failed"); return r.json(); });
  }
  function refreshCount(){
    return fetch("/cart.js").then(function(r){ return r.json(); }).then(function(c){
      var sel = '.cart-count,[data-cart-count],#CartCount,[class*="cart"][class*="count"],[class*="cart"][class*="bubble"],[class*="cart"][class*="badge"]';
      Array.prototype.forEach.call(d.querySelectorAll(sel), function(el){
        if(el.children.length === 0) el.textContent = c.item_count;
      });
      try{ d.dispatchEvent(new CustomEvent("cart:refresh",{bubbles:true})); }catch(e){}
      return c;
    });
  }
  function flash(btn, msg){
    if(!btn || btn.__busy) return;
    var old = btn.innerHTML; btn.__busy = true;
    btn.innerHTML = msg; btn.classList.add("is-ok");
    setTimeout(function(){ btn.innerHTML = old; btn.classList.remove("is-ok"); btn.__busy = false; }, 1900);
  }
  /* Añadir al carrito sin salir de la pagina */
  d.addEventListener("submit", function(e){
    var form = e.target;
    if(!form || !form.classList || !form.classList.contains("ro-buyform")) return;
    e.preventDefault();
    var main = form.querySelector("[data-ro-add]");
    var sticky = d.querySelector(".ro-sticky__btn");
    addToCart(form).then(refreshCount).then(function(){
      if(window.__roOpenDrawer){ window.__roOpenDrawer(); } else { flash(main, "\u2713 Agregado"); flash(sticky, "\u2713 Agregado"); }
    }).catch(function(){ window.location.href = "/cart"; });
  }, true);
  /* Comprar ahora: agrega y va directo a pagar */
  d.addEventListener("click", function(e){
    var b = (e.target && e.target.closest) ? e.target.closest("[data-ro-buynow]") : null;
    if(!b) return;
    e.preventDefault();
    var form = b.closest("form.ro-buyform") || d.querySelector("form.ro-buyform");
    if(!form) return;
    var old = b.innerHTML; b.disabled = true; b.innerHTML = "Un momento\u2026";
    addToCart(form).then(function(){ window.location.href = "/checkout"; })
      .catch(function(){ b.disabled = false; b.innerHTML = old; window.location.href = "/cart"; });
  });
})();

/* === LAND · Royale — red de seguridad del reveal === */
(function(){
  if(window.__roRevealFix) return; window.__roRevealFix = true;
  function reveal(){
    var els = document.querySelectorAll(".ro-reveal");
    for(var i=0;i<els.length;i++){ els[i].classList.add("is-in"); }
  }
  if(document.readyState === "loading"){ document.addEventListener("DOMContentLoaded", reveal); } else { reveal(); }
  setTimeout(reveal, 800);
  setTimeout(reveal, 2500);
})();

/* === LAND · Royale — precio y CTA al cambiar de variante === */
(function(){
  if(window.__roVar) return; window.__roVar = true;
  document.addEventListener("change", function(e){
    var s = e.target;
    if(!s || !s.matches || !s.matches("[data-ro-variant]")) return;
    var opt = s.options[s.selectedIndex];
    var price = opt ? opt.getAttribute("data-price") : null;
    if(!price && !(opt && opt.getAttribute("data-img"))) return;
    if(!price) price = "";
    var el = document.querySelector("[data-ro-price]");
    if(el) el.textContent = price;
    var st = document.querySelector(".ro-sticky__price");
    if(st) st.textContent = price;
    /* cambiar la foto principal a la de la variante elegida */
    var vimg = opt ? opt.getAttribute("data-img") : "";
    if(vimg){
      var main = document.querySelector("[data-ro-main]");
      if(main) main.src = vimg;
      var thumbs = document.querySelectorAll("[data-ro-thumb]");
      for(var i=0;i<thumbs.length;i++){
        var same = thumbs[i].getAttribute("data-ro-thumb") === vimg;
        thumbs[i].classList[ same ? "add" : "remove" ]("is-active");
      }
    }
  });
})();

/* === LAND · Royale — carrito deslizante propio === */
(function(){
  if(window.__roDrawer) return; window.__roDrawer = true;
  var d = document;
  function money(c){ return "$ " + (c/100).toLocaleString("es-MX",{minimumFractionDigits:0,maximumFractionDigits:2}); }
  function thumb(u){ return u || ""; }
  function close(){ var w=d.getElementById("roDrawer"); if(w) w.classList.remove("is-open"); d.body.style.overflow=""; }
  function build(){
    var w = d.getElementById("roDrawer");
    if(w) return w;
    w = d.createElement("div"); w.id = "roDrawer";
    w.innerHTML = '<div class="ro-dw__ov" data-dwclose></div><aside class="ro-dw__panel" role="dialog" aria-label="Tu carrito"><div class="ro-dw__head"><span class="ro-dw__title">Agregado a tu carrito</span><button type="button" class="ro-dw__x" data-dwclose aria-label="Cerrar">&times;</button></div><div class="ro-dw__body"></div><div class="ro-dw__foot"><div class="ro-dw__sub"><span>Subtotal</span><b data-dwsub></b></div><a class="ro-btn ro-btn--dark ro-dw__pay" href="/checkout">Ir a pagar</a><button type="button" class="ro-btn ro-btn--buy ro-dw__cont" data-dwclose>Seguir comprando</button><a class="ro-dw__link" href="/cart">Ver carrito completo</a></div></aside>';
    d.body.appendChild(w);
    w.addEventListener("click", function(e){ if(e.target && e.target.closest && e.target.closest("[data-dwclose]")) close(); });
    return w;
  }
  function render(cart){
    var w = build();
    var body = w.querySelector(".ro-dw__body");
    var html = "";
    var items = cart.items || [];
    for(var i=0;i<items.length && i<5;i++){
      var it = items[i];
      var vt = (it.variant_title && it.variant_title !== "Default Title") ? '<div class="ro-dw__v">'+it.variant_title+"</div>" : "";
      html += '<div class="ro-dw__item"><img src="'+thumb(it.image)+'" alt="" loading="eager"><div class="ro-dw__info"><div class="ro-dw__t">'+it.product_title+"</div>"+vt+'<div class="ro-dw__q">'+it.quantity+" &times; "+money(it.price)+"</div></div></div>";
    }
    if(items.length > 5){ html += '<div class="ro-dw__more">y '+(items.length-5)+" producto(s) m\u00e1s</div>"; }
    body.innerHTML = html;
    var sub = w.querySelector("[data-dwsub]"); if(sub) sub.textContent = money(cart.total_price);
    w.classList.add("is-open");
    d.body.style.overflow = "hidden";
  }
  window.__roOpenDrawer = function(){
    return fetch("/cart.js").then(function(r){ return r.json(); }).then(render).catch(function(){});
  };
  d.addEventListener("keydown", function(e){ if(e.key === "Escape") close(); });
})();


/* ============ RO DRAWER v2 (quantity + remove) ============ */
(function(){
  var BUSY=false;
  function fmt(c){ try{ return "$"+(c/100).toLocaleString("es-MX",{minimumFractionDigits:2,maximumFractionDigits:2}); }catch(e){ return "$"+(c/100).toFixed(2); } }
  function esc(s){ return String(s==null?"":s).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;"); }
  function build(){
    var old=document.getElementById("roDrawer");
    if(old && old.parentNode){ old.parentNode.removeChild(old); }
    var d=document.createElement("div");
    d.id="roDrawer";
    var h="";
    h+='<div class="ro-dw__ov" data-dwclose></div>';
    h+='<aside class="ro-dw__panel" role="dialog" aria-label="Carrito">';
    h+='<div class="ro-dw__head"><span class="ro-dw__title">Tu carrito</span>';
    h+='<button type="button" class="ro-dw__x" data-dwclose aria-label="Cerrar">&#215;</button></div>';
    h+='<div class="ro-dw__body"></div>';
    h+='<div class="ro-dw__foot"><div class="ro-dw__sub"><span>Subtotal</span><strong data-dwsub>$0.00</strong></div>';
    h+='<a class="ro-btn ro-btn--dark ro-dw__pay" href="/checkout">Ir a pagar</a>';
    h+='<button type="button" class="ro-dw__cont" data-dwclose>Seguir comprando</button></div></aside>';
    d.innerHTML=h;
    document.body.appendChild(d);
    d.addEventListener("click",onClick,false);
    return d;
  }
  function node(){ return document.getElementById("roDrawer") || build(); }
  function render(cart){
    var d=node();
    var body=d.querySelector(".ro-dw__body");
    var pay=d.querySelector(".ro-dw__pay");
    var items=(cart&&cart.items)||[];
    if(!items.length){
      body.innerHTML='<p class="ro-dw__empty">Tu carrito esta vacio.</p>';
      if(pay){ pay.style.display="none"; }
    } else {
      var h="";
      for(var i=0;i<items.length;i++){
        var it=items[i]; var ln=i+1;
        h+='<div class="ro-dw__item" data-dwrow="'+ln+'">';
        h+= it.image ? '<img class="ro-dw__img" src="'+esc(it.image)+'" alt="" loading="eager">' : '<span class="ro-dw__img"></span>';
        h+='<div class="ro-dw__info">';
        h+='<span class="ro-dw__t">'+esc(it.product_title||it.title)+'</span>';
        if(it.variant_title){ h+='<span class="ro-dw__v">'+esc(it.variant_title)+'</span>'; }
        h+='<span class="ro-dw__q">'+fmt(it.final_price!=null?it.final_price:it.price)+' c/u</span>';
        h+='<div class="ro-dw__ctrls">';
        h+='<button type="button" class="ro-dw__step" data-dwline="'+ln+'" data-dwto="'+(it.quantity-1)+'" aria-label="Quitar uno">&#8722;</button>';
        h+='<span class="ro-dw__qn">'+it.quantity+'</span>';
        h+='<button type="button" class="ro-dw__step" data-dwline="'+ln+'" data-dwto="'+(it.quantity+1)+'" aria-label="Agregar uno">+</button>';
        h+='<button type="button" class="ro-dw__rm" data-dwline="'+ln+'" data-dwto="0">Quitar</button>';
        h+='</div></div>';
        h+='<span class="ro-dw__lt">'+fmt(it.final_line_price!=null?it.final_line_price:it.line_price)+'</span>';
        h+='</div>';
      }
      body.innerHTML=h;
      if(pay){ pay.style.display=""; }
    }
    var sub=d.querySelector("[data-dwsub]");
    if(sub){ sub.textContent=fmt((cart&&(cart.items_subtotal_price!=null?cart.items_subtotal_price:cart.total_price))||0); }
    counts((cart&&cart.item_count)||0);
  }
  function counts(n){
    var sel=".cart-count-bubble span,[data-cart-count],.cart-count,.header__cart-count,.js-cart-count,.cart-link__bubble-num,.site-header__cart-indicator,.cart-item-count";
    var els=document.querySelectorAll(sel);
    for(var i=0;i<els.length;i++){ els[i].textContent=String(n); }
  }
  function busy(on){
    BUSY=on;
    var p=node().querySelector(".ro-dw__panel");
    if(p){ p.classList[on?"add":"remove"]("is-busy"); }
  }
  function load(){
    return fetch("/cart"+".js",{headers:{"Accept":"application/json"},credentials:"same-origin"}).then(function(r){ return r.json(); });
  }
  function change(line,qty){
    if(BUSY){ return; }
    if(qty<0){ qty=0; }
    busy(true);
    fetch("/cart/change"+".js",{ method:"POST", headers:{"Content-Type":"application/json","Accept":"application/json"}, credentials:"same-origin", body:JSON.stringify({line:line,quantity:qty}) })
      .then(function(r){ return r.json(); })
      .then(function(c){ render(c); busy(false); try{ document.dispatchEvent(new CustomEvent("ro:cart:updated",{detail:c})); }catch(e){} })
      ["catch"](function(){ busy(false); load().then(render)["catch"](function(){}); });
  }
  function onClick(e){
    var t=e.target; if(!t||!t.closest){ return; }
    var c=t.closest("[data-dwline]");
    if(c){ e.preventDefault(); e.stopPropagation(); change(parseInt(c.getAttribute("data-dwline"),10), parseInt(c.getAttribute("data-dwto"),10)); return; }
    var x=t.closest("[data-dwclose]");
    if(x){ e.preventDefault(); closeDw(); }
  }
  function closeDw(){
    var d=document.getElementById("roDrawer");
    if(d){ d.classList.remove("is-open"); }
    document.documentElement.classList.remove("ro-dw-lock");
  }
  function openDw(){
    var d=node();
    d.classList.add("is-open");
    document.documentElement.classList.add("ro-dw-lock");
    load().then(render)["catch"](function(){});
  }
  window.__roOpenDrawer=openDw;
  window.__roCloseDrawer=closeDw;
  window.__roDrawerV2=true;
  document.addEventListener("keydown",function(e){ if(e.key==="Escape"||e.keyCode===27){ closeDw(); } },false);
  if(document.readyState!=="loading"){ build(); } else { document.addEventListener("DOMContentLoaded",build,false); }
})();


/* header cart icon -> slide drawer instead of navigating */
(function(){
  document.addEventListener("click", function(e){
    var t=e.target; if(!t||!t.closest){ return; }
    var a=t.closest("a[href]");
    if(!a || a.hasAttribute("data-dwskip") || a.closest("#roDrawer")){ return; }
    var h=a.getAttribute("href")||"";
    if(/^(?:https?:\/\/[^\/]+)?\/cart\/?(?:\?.*)?$/.test(h)){
      if(window.__roOpenDrawer){ e.preventDefault(); window.__roOpenDrawer(); }
    }
  }, false);
})();


/* prefer the theme native slide-out cart, fall back to ro drawer */
(function(){
  var mine=window.__roOpenDrawer;
  function nativeBtn(){
    var els=document.querySelectorAll(".js-mini-cart-trigger");
    for(var i=0;i<els.length;i++){ var r=els[i].getBoundingClientRect(); if(r.width>0&&r.height>0){ return els[i]; } }
    return null;
  }
  window.__roOpenDrawer=function(){
    var b=nativeBtn();
    if(b){ try{ b.click(); return; }catch(e){} }
    if(mine){ mine(); }
  };
})();


/* ============ ADD-ON: agregar en 1 clic ============ */
(function(){
  document.addEventListener("click", function(e){
    var t=e.target; if(!t||!t.closest){ return; }
    var b=t.closest("[data-ro-addon]");
    if(!b){ return; }
    e.preventDefault(); e.stopPropagation();
    if(b.getAttribute("data-busy")==="1"){ return; }
    var id=b.getAttribute("data-vid");
    if(!id){ return; }
    var old=b.getAttribute("data-label") || b.textContent;
    b.setAttribute("data-label", old);
    b.setAttribute("data-busy","1");
    b.textContent="Agregando...";
    fetch("/cart/add"+".js",{ method:"POST", headers:{"Content-Type":"application/json","Accept":"application/json"}, credentials:"same-origin", body:JSON.stringify({id:id,quantity:1}) })
      .then(function(r){ if(!r.ok){ throw new Error("add"); } return r.json(); })
      .then(function(){
        b.textContent="\u2713 Agregado";
        b.classList.add("is-ok");
        if(window.__roOpenDrawer){ window.__roOpenDrawer(); }
        setTimeout(function(){ b.textContent=old; b.classList.remove("is-ok"); b.removeAttribute("data-busy"); }, 2600);
      })
      ["catch"](function(){ b.textContent=old; b.removeAttribute("data-busy"); });
  }, false);
})();
